export class HeatmapCoordinate {
  x: number;
  y: number;
  value: number;
}
